import { render, staticRenderFns } from "./InstructionStepCard.vue?vue&type=template&id=06aa6250&scoped=true"
import script from "./InstructionStepCard.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionStepCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InstructionStepCard.vue?vue&type=style&index=0&id=06aa6250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06aa6250",
  null
  
)

export default component.exports